import * as api from '@codegrade/api';
import { Nothing } from '@codegrade/maybe';
import { sort } from '@codegrade/utils';
import { AutoTestStore } from '@/store/modules/autotest';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class AutoTestRun {
    id;
    createdAt;
    autoTestId;
    isExtended;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, createdAt, autoTestId, isExtended) {
        this.id = id;
        this.createdAt = createdAt;
        this.autoTestId = autoTestId;
        this.isExtended = isExtended;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data, autoTestId) {
        return new AutoTestRun(data.id, data.createdAt, autoTestId, data instanceof api.ExtendedAutoTestRun);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get results() {
        // If we don't have an extended result we might still have some results
        // which we loaded individually, however getting the latest results will
        // not work.
        if (!this.isExtended) {
            return Nothing;
        }
        return AutoTestStore.getTest()(this.autoTestId).chain(AutoTestStore.getLatestResults());
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get sortedResults() {
        return this.results.map(results => sort.sortBy(results, result => result.getSortKeys()));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    findResultBySubId(submissionId) {
        return AutoTestStore.getResultBySubmission()(this.id, submissionId);
    }
}
